import { memo } from 'react';
import styled from 'foundations-theming/utils';
import { Flex } from 'foundations-components/components/Flex';
import { BlockIcon, SettingsIcon, VolumeMuteIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledMenuOptions = styled.button.withConfig({
  displayName: "DropdownOption__StyledMenuOptions",
  componentId: "cuk537-0"
})(({
  theme
}) => {
  return {
    color: theme.color['text-core-default'],
    border: 'none',
    backgroundColor: theme.color['icon-core-on-fill-default'],
    padding: `${theme.space['200']} ${theme.space['500']} !important`,
    fontSize: theme.typography['detail-100'].fontSize,
    fontWeight: theme.typography['detail-100'].fontWeight,
    textAlign: 'left',
    width: '100%',
    '&:hover': {
      backgroundColor: theme.color['fill-field-hover']
    }
  };
});
const getIconComponent = icon => {
  switch (icon) {
    case 'block':
      return BlockIcon;
    case 'settings':
      return SettingsIcon;
    case 'volumeMute':
      return VolumeMuteIcon;
    default:
      throw new Error(`Unknown icon ${icon}`);
  }
};
const DropdownOption = ({
  iconName,
  id,
  label,
  onClick
}) => {
  const Icon = getIconComponent(iconName);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledMenuOptions, {
      "aria-label": label,
      "data-test-id": id,
      id: id,
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Flex, {
          marginInlineEnd: "200",
          paddingBlockStart: "50",
          children: /*#__PURE__*/_jsx(Icon, {
            size: "100",
            color: "icon-core-subtle"
          })
        }), label]
      })
    })
  );
};
export default /*#__PURE__*/memo(DropdownOption);